import styled from 'styled-components';
import { devices } from '@/UI/Styles';

export const Wrapper = styled.div`
  width: 100%;
  border-radius: 0px 0px 8px 8px;
  padding-bottom: 50px;
  @media ${devices.XLarge} {
    border-radius: 8px;
    width: auto;
  }
`;

export const ReservationSummaryContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  border-radius: 8px;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  margin-bottom: 100px;
  ::-webkit-scrollbar {
    display: none;
  }
  .grayText {
    color: ${({ theme }) => theme.palette.grays50} !important;
  }
  min-height: 70vh;
  @media ${devices['no-mobile']} {
    width: 500px;
    margin-bottom: 25px;
    border-radius: 8px;
  }
  @media ${devices.Medium} {
    width: 100%;
    padding: ${({ theme }) => theme.spacing[16]};
  }
  @media ${devices.XLarge} {
    width: 360px;
  }
`;

export const TitleWrapper = styled.div`
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: ${({ theme }) => theme.spacing[16]};
  padding: 20px 0px;
`;

export const TotalWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing[16]};
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: ${({ theme }) => theme.spacing[8]};
  border-radius: ${({ theme }) => theme.borderRadius.md};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .text {
    display: flex;
    align-items: center;
  }
  path {
    fill: ${({ theme }) => theme.brandTheme.brand100};
  }
`;

export const DisclaimerWrapper = styled.div<{ isDiscount?: boolean }>`
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: ${({ theme }) => theme.spacing[8]};
  width: ${({ isDiscount }) => (isDiscount ? '80%' : '100%')};
  margin: ${({ theme }) => theme.spacing[4]} auto;
  display: flex;
  column-gap: ${({ theme }) => theme.spacing[8]};
  align-items: ${({ isDiscount }) => (isDiscount ? 'center' : 'start')};
  background: ${({ isDiscount, theme }) => (isDiscount ? '' : theme.palette.orange50)};
  path {
    fill: ${({ isDiscount, theme }) => (isDiscount ? theme.brandTheme.brand100 : theme.palette.orange500)};
  }
  svg {
    max-height: 20px;
  }
  .text {
    font-size: ${({ theme }) => theme.fontSize['xsmall-desktop']};
  }
`;
